import React from 'react';
import { Breadcrumbs, Btn, H5 } from '../../../AbstractElements';
import { Card, CardBody, CardFooter, CardHeader, Col, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import UsersNewForm from './UsersNewForm';

const UsersNew = () => {
  return (
    <>
      <Breadcrumbs mainTitle="User" title="New user" subParent="Users" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <H5>New user</H5>
                <Link to="/users">
                  <Btn color="primary">Back to users</Btn>
                </Link>
              </CardHeader>
              <CardBody>
                <UsersNewForm />
              </CardBody>
              <CardFooter>
                <Btn color="primary">Create</Btn>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default UsersNew;
